export enum PageMode {
  FULL = 'FULL',
  FORM = 'FORM',
  FORM_DETACHED = 'FORM_DETACHED',
}
